import { makeStyles } from 'tss-react/mui'

export default makeStyles()((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 2,
    color: '#fff',
  }
}))
